import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import AddGoal from '../components/Goals/AddGoal';
import GoalsList from '../components/Goals/GoalsList';
import styles from '../styles/Goals.module.scss';
import FastGoals from '../components/FastGoals/FastGoals';

const Goals = () => {
  const [goals, setGoals] = useState([]);

  async function loadGoals() {
    const res = await fetch('/api/goals/summary');
  
    if (!res.ok) {
      const text = await res.text().catch(() => '');
      console.error('summary error:', res.status, text);
      setGoals([]);
      return;
    }
  
    const data = await res.json();
    setGoals(Array.isArray(data) ? data : []);
  }
  
  useEffect(() => {
    loadGoals();
  }, []);

  const handleDeleted = (id) => {
    setGoals((prev) => prev.filter((g) => g.id !== id));
  };

  const handleUpdated = (updatedGoal) => {
    if (!updatedGoal) return;

    if (updatedGoal.removed) {
      setGoals((prev) => prev.filter((g) => g.id !== updatedGoal.id));
      return;
    }

    setGoals((prev) =>
      prev.map((g) => (g.id === updatedGoal.id ? updatedGoal : g))
    );
  };

  const triggerAddGoal = () => {
    const btn = document.querySelector('[data-add-goal-btn="true"]');
    if (btn) btn.click();
  };

  return (
    <>
      <Helmet>
        <title>ФА | Цели</title>
      </Helmet>

      <div className={styles.goals__wrapper}>
        <div className={styles.goals__left}>
          <div className={styles.goals__header}>
            <div className={styles.goals__titleBlock}>
              <h2 className={styles.goals__title}>Финансовые цели:</h2>
            </div>

            <AddGoal onCreated={loadGoals} />
          </div>

          <GoalsList
            goals={goals}
            onDeleted={handleDeleted}
            onUpdated={handleUpdated}
            onAddGoal={triggerAddGoal}
          />
        </div>

        <div className={styles.goals__right}>
          <FastGoals />
        </div>
      </div>
    </>
  );
};

export default Goals;